import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/additives/catalog`;

export const additivesCatalogAPI = {
  listProducts: () => apiClient(`${BASE}/products`),
  createProduct: (data) =>
    apiClient(`${BASE}/products`, { method: 'POST', body: JSON.stringify(data) }),
  updateProduct: (id, data) =>
    apiClient(`${BASE}/products/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  removeProduct: (id) => apiClient(`${BASE}/products/${id}`, { method: 'DELETE' }),

  listStandards: () => apiClient(`${BASE}/standards`),
  createStandard: (data) =>
    apiClient(`${BASE}/standards`, { method: 'POST', body: JSON.stringify(data) }),
  updateStandard: (id, data) =>
    apiClient(`${BASE}/standards/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  removeStandard: (id) => apiClient(`${BASE}/standards/${id}`, { method: 'DELETE' }),

  listCompetitors: () => apiClient(`${BASE}/competitors`),
  createCompetitor: (data) =>
    apiClient(`${BASE}/competitors`, { method: 'POST', body: JSON.stringify(data) }),
  updateCompetitor: (id, data) =>
    apiClient(`${BASE}/competitors/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  removeCompetitor: (id) => apiClient(`${BASE}/competitors/${id}`, { method: 'DELETE' }),
};

export default additivesCatalogAPI;
